import {
  Avatar,
  Box,
  Button,
  Card,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Switch,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { poppins500 } from 'theme/common.style';
import Loading from 'assets/images/loading.png';
import { useTheme } from '@mui/styles';
const MarkerPen = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.52713 14.378L7.0525 14.5253C6.43805 14.7159 5.78336 15.0481 5.15941 15.4858L5.14931 15.4929L4.70044 15.0441L4.70764 15.034C5.14523 14.41 5.47743 13.7553 5.6681 13.1409L5.81535 12.6664C5.84571 12.5685 5.79101 12.4645 5.69319 12.4341C5.59552 12.4039 5.49139 12.4584 5.46096 12.5563L5.31371 13.0309C5.13432 13.609 4.81971 14.228 4.40386 14.8208L4.30715 14.9585C4.25535 15.0322 4.26403 15.1326 4.32778 15.1963L4.99709 15.8655C5.03294 15.9014 5.08051 15.9198 5.12838 15.9198C5.16542 15.9198 5.20267 15.9088 5.23496 15.8861L5.37256 15.7895C5.96535 15.3736 6.58426 15.059 7.1625 14.8796L7.63712 14.7323C7.73495 14.702 7.78972 14.598 7.75929 14.5002C7.72893 14.4023 7.62503 14.3476 7.52713 14.378Z"
        fill="#A58BC9"
      />
      <path
        d="M13.3246 4.92548C13.2521 4.85297 13.1347 4.85297 13.0623 4.92548L6.70449 11.2833L5.98798 11.9999C5.91547 12.0723 5.91547 12.1898 5.98798 12.2622L7.93184 14.2061C7.96806 14.2423 8.01556 14.2604 8.06306 14.2604C8.11056 14.2604 8.15799 14.2423 8.19428 14.2061L8.91086 13.4895L15.2686 7.1317C15.3411 7.05927 15.3411 6.94178 15.2686 6.86934L13.3246 4.92548ZM8.06299 13.8125L6.38148 12.131L6.83563 11.6769L8.33849 13.1796L8.5172 13.3584L8.06299 13.8125ZM8.77957 13.0959L7.27671 11.5931L7.09799 11.4144L13.1934 5.31906L14.8749 7.00056L8.77957 13.0959Z"
        fill="#A58BC9"
      />
      <path
        d="M15.5528 5.50901L14.6849 4.64102C14.4967 4.45295 14.1907 4.45303 14.0027 4.64102L13.8015 4.84216C13.7289 4.91467 13.7289 5.03208 13.8015 5.1046C13.874 5.17711 13.9914 5.17703 14.0638 5.1046L14.265 4.90346C14.3084 4.86012 14.3789 4.86004 14.4225 4.90346L15.2904 5.77145C15.3114 5.79253 15.323 5.82051 15.323 5.8502C15.323 5.87996 15.3114 5.90786 15.2904 5.92894L15.0893 6.13008C15.0168 6.20259 15.0168 6.32 15.0893 6.39251C15.1255 6.42873 15.173 6.44684 15.2205 6.44684C15.268 6.44684 15.3155 6.42873 15.3517 6.39251L15.5529 6.19138C15.644 6.10024 15.6942 5.97911 15.6942 5.8502C15.6941 5.72128 15.644 5.60008 15.5528 5.50901Z"
        fill="#A58BC9"
      />
    </svg>
  );
};

const Delete = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.655 21.0002H12.3268C11.9162 21.0002 11.5732 20.6793 11.5459 20.2696L11.0381 12.6523H19.9436L19.4358 20.2696C19.4086 20.6793 19.0656 21.0002 18.655 21.0002ZM11.5958 13.1741L12.0665 20.2349C12.0756 20.3715 12.1899 20.4784 12.3268 20.4784H18.6549C18.7918 20.4784 18.9061 20.3715 18.9151 20.2349L19.3859 13.1741H11.5958Z"
        fill="#A58BC9"
      />
      <path
        d="M19.9252 12.1309H11.0557V10.8266C11.0557 10.395 11.4067 10.0439 11.8383 10.0439H19.1426C19.5742 10.0439 19.9252 10.395 19.9252 10.8266V12.1309ZM11.5774 11.6092H19.4035V10.8266C19.4035 10.6827 19.2865 10.5657 19.1426 10.5657H11.8383C11.6944 10.5657 11.5774 10.6827 11.5774 10.8266V11.6092Z"
        fill="#A58BC9"
      />
      <path
        d="M20.7082 11.6084H10.2734V12.1301H20.7082V11.6084Z"
        fill="#A58BC9"
      />
      <path
        d="M14.1861 19.4342H13.6643C13.3762 19.4342 13.1426 19.2006 13.1426 18.9124V14.7385C13.1426 14.4504 13.3762 14.2168 13.6643 14.2168H14.1861C14.4742 14.2168 14.7078 14.4504 14.7078 14.7385V18.9124C14.7078 19.2006 14.4742 19.4342 14.1861 19.4342Z"
        fill="#FCFCFC"
      />
      <path
        d="M14.1862 19.6952H13.6644C13.2329 19.6952 12.8818 19.3441 12.8818 18.9126V14.7387C12.8818 14.3071 13.2329 13.9561 13.6644 13.9561H14.1862C14.6177 13.9561 14.9688 14.3071 14.9688 14.7387V18.9126C14.9688 19.3442 14.6177 19.6952 14.1862 19.6952ZM13.6644 14.4778C13.5206 14.4778 13.4036 14.5948 13.4036 14.7387V18.9126C13.4036 19.0564 13.5206 19.1734 13.6644 19.1734H14.1862C14.33 19.1734 14.4471 19.0564 14.4471 18.9126V14.7387C14.4471 14.5948 14.33 14.4778 14.1862 14.4778H13.6644Z"
        fill="#A58BC9"
      />
      <path
        d="M17.3169 19.4342H16.7952C16.507 19.4342 16.2734 19.2006 16.2734 18.9124V14.7385C16.2734 14.4504 16.507 14.2168 16.7952 14.2168H17.3169C17.6051 14.2168 17.8387 14.4504 17.8387 14.7385V18.9124C17.8387 19.2006 17.6051 19.4342 17.3169 19.4342Z"
        fill="#FCFCFC"
      />
      <path
        d="M17.317 19.6952H16.7953C16.3638 19.6952 16.0127 19.3441 16.0127 18.9126V14.7387C16.0127 14.3071 16.3638 13.9561 16.7953 13.9561H17.317C17.7486 13.9561 18.0997 14.3071 18.0997 14.7387V18.9126C18.0997 19.3442 17.7486 19.6952 17.317 19.6952ZM16.7953 14.4778C16.6515 14.4778 16.5344 14.5948 16.5344 14.7387V18.9126C16.5344 19.0564 16.6515 19.1734 16.7953 19.1734H17.317C17.4609 19.1734 17.5779 19.0564 17.5779 18.9126V14.7387C17.5779 14.5948 17.4609 14.4778 17.317 14.4778H16.7953Z"
        fill="#A58BC9"
      />
      <path
        d="M16.7952 10.5652H14.1865V9.78261C14.1865 9.35108 14.5376 9 14.9691 9H16.0126C16.4441 9 16.7952 9.35108 16.7952 9.78261V10.5652ZM14.7083 10.0435H16.2735V9.78261C16.2735 9.63877 16.1565 9.52174 16.0126 9.52174H14.9691C14.8253 9.52174 14.7083 9.63877 14.7083 9.78261V10.0435Z"
        fill="#A58BC9"
      />
    </svg>
  );
};
export const DownArrowIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="23"
        height="23"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M13.2815 16.006C12.7866 16.5418 11.94 16.5418 11.4451 16.006L7.3733 11.5982C6.63374 10.7976 7.20158 9.5 8.29149 9.5L16.4351 9.5C17.525 9.5 18.0928 10.7976 17.3533 11.5982L13.2815 16.006Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
const Location = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.0179 1.70609C4.94521 1.69565 2.43543 4.14029 2.33512 7.20029L2.33203 7.39022C2.3831 8.8901 2.89341 10.3198 3.79222 11.4978L4.00331 11.7733C4.86123 12.8641 5.88077 13.8216 7.02555 14.6108L7.30118 14.7963L7.34139 14.8279C7.73376 15.1098 8.26354 15.1098 8.65591 14.8279L8.68938 14.8004C9.59774 14.2113 10.4354 13.5191 11.1857 12.7376C12.7111 11.1229 13.6305 9.31355 13.6652 7.47604L13.6653 7.40782C13.6757 4.32734 11.2386 1.80983 8.188 1.70918L8.0179 1.70609ZM8.01437 2.72034C10.5334 2.72895 12.5786 4.74164 12.6545 7.2481L12.6567 7.4691C12.6275 9.00965 11.8209 10.597 10.4563 12.0415C9.76055 12.7662 8.98042 13.4104 8.1343 13.9583L8.07791 14.0007C8.03234 14.0403 7.96475 14.0403 7.91918 14.0007L7.86437 13.9594C6.60391 13.1364 5.49764 12.0974 4.59617 10.8898C3.87005 9.93816 3.43977 8.80029 3.35316 7.61329L3.34043 7.37527C3.34899 4.85017 5.35548 2.79868 7.85423 2.7225L8.01437 2.72034ZM7.99871 5.30519C6.80645 5.30519 5.83993 6.27469 5.83993 7.47064C5.83993 8.66658 6.80645 9.63608 7.99871 9.63608C9.19098 9.63608 10.1575 8.66658 10.1575 7.47064C10.1575 6.27469 9.19098 5.30519 7.99871 5.30519ZM7.99863 6.31953C8.63391 6.31953 9.14891 6.83612 9.14891 7.47336C9.14891 8.11061 8.63391 8.62719 7.99863 8.62719C7.36335 8.62719 6.84835 8.11061 6.84835 7.47336C6.84835 6.83612 7.36335 6.31953 7.99863 6.31953Z"
        fill="#112347"
      />
    </svg>
  );
};
export const UpDownArrowIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="23"
        height="23"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M8.36328 15L12.3633 19L16.3633 15"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.36328 9L12.3633 5L16.3633 9"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const TaskPageFeedbackAll = ({
  address,
  loaderpart,
  combinedData,
  OwnerExpanded,
  noteToEdit,
  setValue,
  setNoteToEdit,
  setIsNoteEdit,
  updateNoteScrollRef,
  setTaskToEdit,
  taskRefs,
  getTask,
  setIsEdit,
  taskToEdit,
  selectedProperty,
  updateTaskScrollRef,
  value,
  handleDeleteNote,
  handleDeleteTask,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid container sx={{ width: '100%', marginBottom: '20px' }}>
      {loaderpart ? (
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            p: '10%',
            width: '100%',
          }}
        >
          <img
            alt="Logo"
            src={Loading}
            className="loaderImage"
            style={{ height: '75px', width: '75px' }}
          />
        </Grid>
      ) : combinedData.length > 0 ? (
        combinedData.map((item, index) => (
          <Grid item sx={{ display: 'flex', width: '100%' }}>
            <Grid item xs={12}>
              <Card
                sx={{
                  borderRadius: '5px',
                  padding: '5px',
                  marginTop: '15px',
                  background: '#FFFFFF',
                  justifyContent: 'space-between',
                  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                }}
              >
                <Stack spacing={'2'}>
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '600 !important',
                        fontSize: '16px',
                        textTransform: 'capitalize',
                        color: 'white',
                        background: '#00cbef',
                        padding: '2px 5px',
                        borderRadius: '5px',
                      }}
                    >
                      {item?.isTask ? 'Task' : 'Note'}
                    </Typography>
                  </Grid>
                  <Stack spacing={'2'}>
                    <Grid container justifyContent={'space-between'}>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '500 !important',
                            fontSize: '14px',
                            lineHeight: '21px',
                            // marginTop: "10px",
                            color: '#585858',
                          }}
                        >
                          Subject: &nbsp;
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '400 !important',
                            fontSize: '14px',
                            lineHeight: '21px',
                            // marginTop: "10px",
                            color: '#585858',
                          }}
                        >
                          {item.subject}
                        </Typography>
                      </Stack>
                      <Grid item>
                        <Grid
                          container
                          justify
                          justifyContent={'space-between'}
                        >
                          <Grid item xs={4}>
                            <Stack sx={{ padding: '4px' }}>
                              <UpDownArrowIcon />
                            </Stack>
                          </Grid>
                          <Grid
                            item
                            xs={4}
                            sx={{
                              marginRight: '10px',
                            }}
                          >
                            <Stack sx={{ padding: '4px' }}>
                              <DownArrowIcon />
                            </Stack>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Stack>
                  <Grid
                    item
                    sx={{
                      display: 'flex',
                      flexDirection: matchessm ? 'column' : 'row',
                      justifyContent: 'space-between',
                      alignItems: matchessm ? 'flex-start' : 'center',
                      gap: matchessm ? '10px' : 'auto',
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '14px',
                        textTransform: 'capitalize',
                        color: '#666666',
                      }}
                    >
                      Created: {item?.createdAt}&nbsp;
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '14px',
                        textTransform: 'capitalize',
                        color: '#585858',
                      }}
                    >
                      Added by{' '}
                      {item?.isTask
                        ? item?.transobject?.creator?.name
                        : item?.agentName}{' '}
                      &nbsp;
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '14px',
                        textTransform: 'capitalize',
                        color: ' #112347',
                        marginLeft: matchessm ? '0px' : '4px',
                        display: 'flex',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Box sx={{ marginTop: matchessm ? '3px' : '0px' }}>
                        <Location />
                      </Box>
                      {address} &nbsp;
                    </Typography>
                  </Grid>
                  <Stack>
                    <Grid
                      container
                      sx={{
                        display: 'flex',
                        flexDirection: matchessm ? 'column' : 'row',
                        width: '100%',
                      }}
                    >
                      <Grid
                        item
                        sx={{
                          display: 'flex',
                          width: matchessm ? '100%' : '70%',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '400 !important',
                            fontSize: '14px',
                            color: ' #200E32',
                            lineHeight: '21px',
                            marginTop: '10px',
                          }}
                        >
                          {item?.description}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sx={{
                          display: 'flex',
                          width: matchessm ? '100%' : '30%',
                          flexDirection: matchessm ? 'row' : 'column',
                          alignItems: 'flex-end',
                          padding: '0px',
                          gap: '14px',
                        }}
                      >
                        <Grid
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '0px',
                            justifyContent: 'space-around',
                            // width: "54px",
                            height: '30px',
                          }}
                        >
                          {!item?.object_type == 'signature' && (
                            <IconButton
                              disabled={item?.object_type == 'signature'}
                              onClick={() => {
                                item.isTask
                                  ? setIsEdit(true)
                                  : setIsNoteEdit(true);

                                item.isTask
                                  ? setTaskToEdit(item)
                                  : setNoteToEdit(item);

                                const tabvalue = item.isTask ? 1 : 0;

                                setValue((prev) => {
                                  if (prev !== tabvalue) {
                                    setTimeout(() => {
                                      updateTaskScrollRef.current?.scrollIntoView(
                                        { behavior: 'smooth', block: 'end' }
                                      );
                                    }, !tabvalue);
                                  } else {
                                    updateNoteScrollRef.current?.scrollIntoView(
                                      {
                                        behavior: 'smooth',
                                        block: 'end',
                                      }
                                    );
                                  }
                                  return tabvalue;
                                });
                              }}
                            >
                              <MarkerPen />
                            </IconButton>
                          )}
                          {!item?.object_type == 'signature' && (
                            <IconButton
                              disabled={item?.object_type == 'signature'}
                              onClick={() => {
                                item.isTask
                                  ? handleDeleteTask(item)
                                  : handleDeleteNote(item);
                              }}
                            >
                              <Delete />
                            </IconButton>
                          )}
                        </Grid>
                        <Grid
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'end',
                            alignItems: 'flex-start',
                            padding: '0px',
                            gap: '14px',
                            width: matchessm ? '100%' : '181px',
                          }}
                        >
                          <Box>
                            <Box
                              sx={{
                                // width: "99px",
                                height: '17px',
                                background: !item?.isTask
                                  ? '#345B83'
                                  : item.status == 'pending'
                                  ? 'red'
                                  : item.status === 'active'
                                  ? 'orange'
                                  : item.status === 'completed'
                                  ? 'green'
                                  : '#345B83',
                                borderRadius: '5px',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'flex-start',
                                padding: '1px 10px',
                              }}
                            >
                              <Typography
                                sx={{
                                  color: '#FFFFFF',
                                  ...poppins500,
                                  fontSize: '12px',
                                }}
                              >
                                {' '}
                                {!item?.isTask
                                  ? '#VendorReport'
                                  : item.status == 'pending'
                                  ? 'Overdue'
                                  : item.status === 'active'
                                  ? 'Due'
                                  : item.status === 'completed'
                                  ? 'Completed'
                                  : item.status}
                              </Typography>
                            </Box>
                          </Box>
                          <Box>
                            <Box
                              sx={{
                                width: '72px',
                                height: '17px',
                                background: '#F39800',
                                borderRadius: ' 5px',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'flex-start',
                                padding: '1px 10px',
                              }}
                            >
                              <Typography
                                sx={{
                                  color: '#FFFFFF',
                                  ...poppins500,
                                  fontSize: '12px',
                                }}
                              >
                                #Private
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Stack>
                </Stack>
              </Card>
            </Grid>
          </Grid>
        ))
      ) : (
        <Typography
          sx={{
            fontWeight: 400,
            fontFamily: 'poppins',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '25px',
            color: '#666666',
          }}
        >
          Not available
        </Typography>
      )}
    </Grid>
  );
};
export default TaskPageFeedbackAll;
